import Stack from "@mui/material/Stack";
import { useEffect, useState } from "react";
import { Theme } from "../../data/style/Theme";
import useScreenSize from "../../context/ScreenContext";
import { MainText, AllCenteredColumn } from "../../data/style/Style";

const CountdownTimer = ({ targetTimestamp }) => {
  const [timeLeft, setTimeLeft] = useState(getTimeRemaining(targetTimestamp));
  const { mobileDevice } = useScreenSize();

  useEffect(() => {
    const interval = setInterval(() => {
      const remaining = getTimeRemaining(targetTimestamp);
      setTimeLeft(remaining);

      if (remaining.total <= 0) {
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [targetTimestamp]);

  if (timeLeft.total <= 0) {
    return (
      <Stack
        sx={{
          background: "rgba(255,59,92,.1)",
          border: "1px solid rgba(255,59,92,.25)",
          borderRadius: 3,
          alignItems: "center",
          justifyContent: "center",
          padding: "5px",
          width: mobileDevice ? "80px" : "120px",
        }}
      >
        <MainText
          sx={{
            color: Theme.palette.down + " !important",
            fontSize: mobileDevice ? "0.7rem !important" : "0.9rem !important",
          }}
        >
          Time's up!
        </MainText>
      </Stack>
    );
  }

  return (
    <AllCenteredColumn
      sx={{
        background: Theme.palette.border,
        borderRadius: 3,
        padding: "5px",
        width: mobileDevice ? "100px" : "120px",
      }}
    >
      <MainText
        sx={{
          color:
            timeLeft.days >= 1
              ? Theme.palette.up + " !important"
              : Theme.palette.down + " !important",
          fontSize: mobileDevice ? "0.7rem !important" : "0.9rem !important",
        }}
      >
        {timeLeft.days > 0 ? (
          <>
            {timeLeft.days} days {timeLeft.hours} hours
          </>
        ) : timeLeft.hours > 0 ? (
          <>
            {timeLeft.hours} hours {timeLeft.minutes} mins
          </>
        ) : (
          <>
            {timeLeft.minutes} mins {timeLeft.seconds} secs
          </>
        )}
      </MainText>
    </AllCenteredColumn>
  );
};

// Helper function
function getTimeRemaining(targetTimestamp) {
  const normalized = normalizeTimestamp(targetTimestamp);
  const total = Math.max(normalized - Date.now(), 0);
  const seconds = Math.floor((total / 1000) % 60);
  const minutes = Math.floor((total / 1000 / 60) % 60);
  const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
  const days = Math.floor(total / (1000 * 60 * 60 * 24));
  return { total, days, hours, minutes, seconds };
}

function normalizeTimestamp(ts) {
  return ts < 1000000000000 ? ts * 1000 : ts;
}

export default CountdownTimer;
